import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BlogCard } from "@/pages/Blog";

export function MostShared({ b }: any) {
  const [posts, setPosts] = useState<any[]>([]);
  useEffect(() => { api.get("/blog-most-shared", { params: { limit: Number(b.count) || 3 } }).then((r) => setPosts(r.data)).catch(() => {}); }, [b.count]);
  if (!posts.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-5 md:px-8 py-20 md:py-24" data-testid="most-shared-block">
      <div className="text-center mb-12">
        <h2 className="font-display uppercase text-3xl md:text-[2.4rem] tracking-[0.04em]">{b.heading || "Most Shared Stories"}</h2>
        {b.subheading && <p className="mt-3 text-sm md:text-base text-neutral-600">{b.subheading}</p>}
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-14" data-testid="most-shared-grid">{posts.map((p) => <BlogCard key={p.id} p={p} />)}</div>
      <div className="text-center mt-14"><Link to="/blog?sort=shared" className="inline-block border border-neutral-900 rounded-full px-12 py-3 text-[13px] font-medium uppercase hover:bg-neutral-900 hover:text-white transition-colors" data-testid="most-shared-all">See all stories</Link></div>
    </section>
  );
}
